import { render, staticRenderFns } from "./chart-stats-qty-modeltype.app.vue?vue&type=template&id=b288f736&"
import script from "./chart-stats-qty-modeltype.app.vue?vue&type=script&lang=js&"
export * from "./chart-stats-qty-modeltype.app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports